var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import DynamicLinkTab from './DynamicLinkTab';
import DropdownTabItem from './DropdownTabItem';
import SubMenu from './SubMenu';
import SubTabItem from './SubTab';
const DropdownMenu = (_a) => {
    var { tabs } = _a, restProps = __rest(_a, ["tabs"]);
    return (React.createElement(React.Fragment, null, tabs.map(tab => {
        const subsNum = (tab.subs && tab.subs.length) || 0;
        const isLastOfGroup = (index) => index === subsNum - 1 ||
            (index < subsNum - 1 &&
                !!tab.subs &&
                tab.subs[index + 1].type === 'divider');
        return (React.createElement(Fragment, { key: tab.key },
            React.createElement(DynamicLinkTab, Object.assign({ TabComponent: DropdownTabItem, id: tab.key, e2eId: "nav_sidebar_dropdown_item", bgColor: "SNOW_100", bgHoverColor: "PRIMARY_200", leftBorderColor: "INK_200" }, tab, restProps)),
            tab.subs && (React.createElement(SubMenu, null, tab.subs.map((subTab, index) => (React.createElement(DynamicLinkTab, Object.assign({ lang: restProps.lang, TabComponent: SubTabItem, e2eId: "nav_sidebar_dropdown_subitem", bgColor: "SNOW_100", bgHoverColor: "PRIMARY_200", leftBorderColor: "INK_200", isLastOfGroup: isLastOfGroup(index) }, subTab))))))));
    })));
};
DropdownMenu.defaultProps = {
    tabs: [],
    lang: 'zh-hant',
};
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map